import { FormEvent } from "react";
import { Alert, AlertDescription } from "~/components/ui/alert";
import { Button } from "~/components/ui/button";
import { Input } from "~/components/ui/input";
import { Textarea } from "~/components/ui/textarea";
import { Label } from "~/components/ui/label";

interface MapFormProps {
  name: string;
  description: string;
  error: string;
  saving: boolean;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onSubmit: (e: FormEvent) => void;
}

export default function MapForm({
  name,
  description,
  error,
  saving,
  onNameChange,
  onDescriptionChange,
  onSubmit,
}: MapFormProps) {
  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <Label htmlFor="name">Map Name *</Label>
        <Input
          id="name"
          type="text"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="My Adventure Map"
          maxLength={200}
          required
          autoFocus
        />
      </div>

      <div className="flex flex-col gap-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
              e.preventDefault();
              const formEvent = new Event("submit", {
                bubbles: true,
                cancelable: true,
              });
              e.currentTarget.form?.dispatchEvent(formEvent);
            }
          }}
          placeholder="Tell us about this adventure map..."
          rows={4}
          maxLength={5000}
          className="resize-y min-h-[100px]"
        />
      </div>

      {error && (
        <Alert variant="destructive">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}

      <Button type="submit" disabled={saving || !name.trim()} size="lg" className="w-full">
        {saving ? "Saving..." : "Create Map"}
      </Button>
    </form>
  );
}
